import { takeLatest, put, call, select } from "redux-saga/effects";
import axios from "../../utils/axios";
import log from "loglevel";
import messages from "../../assets/i18n";
import getEnvParam from "../../utils/getEnvParam";

const orderSampleFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

function* orderSample(payload, page, token) {
	try {
		const { 
			pedido,
			pedidoAmostra,
			descricao,
			nomeFornecedor,
			status,
			dataModificacao,
			dataCadastro
		} = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AMOSTRA_PEDIDO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				listarTodasConcessoesFiltradas(
					pedido: "${pedido ? pedido : ''}"
					pedidoAmostra: "${pedidoAmostra ? pedidoAmostra : ''}"
					descricao: "${descricao ? descricao : ''}"
					nomeFornecedor: "${nomeFornecedor ? nomeFornecedor : ''}"
					${status ? ('status: ' + status) : ''}
					dataModificacao: "${dataModificacao ? dataModificacao : ''}"
					dataCadastro: "${dataCadastro ? dataCadastro : ''}"
					pagina: ${page} 
					max: 10
				) {
					id
					pedido
					pedidoAmostra
					descricao
					status {id descricao}
					dataCadastro
					dataModificacao
					motivo
					nomeFornecedor
					codigoFornecedor
				}
			}`
		};

		const { data } = yield call(orderSampleFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getOrderSamples(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        const nextPage = payload.page + 1;
        let result

        yield put({ type: "SET_ORDER_SAMPLE_LOADING", payload: true });
        
        if (payload.cleanTable) {
            yield put({ type: "CLEAN_ORDER_SAMPLE_LIST" });
        }

		result = yield call(orderSample, payload.filter, payload.page, token);

		if (result) {
            if (result.listarTodasConcessoesFiltradas && result.listarTodasConcessoesFiltradas.length) {
                yield put({
                    type: "SET_ORDER_SAMPLE_LIST",
                    payload: {
                        list: result.listarTodasConcessoesFiltradas,
                        hasMore: true,
                        page: nextPage,
                    }
                });
            } else {
                yield put({
                    type: "SET_ORDER_SAMPLE_LIST",
                    payload: {
                        list: result.listarTodasConcessoesFiltradas,
                        hasMore: false,
                        page: payload.page,
                    }
                });
            }
        }

	} catch (error) {
		log.info(error);
	} finally {
        yield put({ type: "SET_ORDER_SAMPLE_LOADING", payload: false });
	}
}

function* getOrderSampleDetails(payload) {
	try {
        yield put({ type: "SET_ORDER_SAMPLE_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

		const result = yield call(orderSampleDetails, payload.payload, token);

		if (result && result.buscarConcessaoPorId) {
            yield put({ type: "SET_FETCHED_ORDER_SAMPLE_DETAILS", payload: result.buscarConcessaoPorId});
        }
        
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_ORDER_SAMPLE_LOADING", payload: false });
	}
}


function* orderSampleDetails(payload, token) {
	try {
        const { orderSampleId } = payload
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AMOSTRA_PEDIDO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
				query {
					buscarConcessaoPorId(
						id: ${orderSampleId}
					) {
						id
						pedido
						pedidoAmostra
						descricao
						status {id descricao}
						dataCadastro
						dataModificacao
						motivo
						nomeFornecedor
						codigoFornecedor
					}
				}
            `
		};

		const { data } = yield call(orderSampleFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* saveOrderSample(payload) {
	try {
        yield put({ type: "SET_ORDER_SAMPLE_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(saveOrderSampleApi, payload.payload, token);

		if (result && result.data && result.data.salvarConcessao) {
            yield put({ 
						type: "SET_ORDER_SAMPLE_TOAST", 
						payload: {
							showToast: true,
							message: messages[lang].registerSuccess,
							messageType: "toast-success"
					}});
			yield put({ type: "SET_FETCHED_ORDER_SAMPLE_DETAILS", payload: result.data.salvarConcessao});
        } else {
			let message = messages[lang].registerError
			if (result && result.errors) {
				message = result.errors[0].exception.localizedMessage
			}
			yield put({ 
						type: "SET_ORDER_SAMPLE_TOAST", 
						payload: {
							showToast: true,
							message: message,
							messageType: "toast-error"
					}});
        }

        yield put({ type: "SET_ORDER_SAMPLE_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}


function* saveOrderSampleApi(payload, token) {
	try {
        const { 
            id,
            pedido,
            pedidoAmostra,
            descricao,
            status,
            motivo
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AMOSTRA_PEDIDO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
				mutation {
					salvarConcessao(
						input: {
							${id ? "id:" + id : ''}
							pedido: "${pedido}"
							pedidoAmostra: "${pedidoAmostra}"
							descricao: "${descricao}"
							status: ${status}
							motivo: "${motivo}"
						}
					) {
						id
						pedido
						pedidoAmostra
						descricao
						status {id descricao}
						dataCadastro
						dataModificacao
						motivo
						nomeFornecedor
						codigoFornecedor
					}
				}
            `
		};
		return yield call(orderSampleFromApi, options)
	} catch (error) {
		log.info(error);
	}
}

function* validateForConciliation(payload, token) {
	try {
        const { idPedido } = payload
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AMOSTRA_PEDIDO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
			mutation {
				validarAmostraPedidoParaConciliacao(idPedido:"${idPedido}") {
					success,
					messageError
				}
			}
            `
		};

		const { data } = yield call(orderSampleFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* validateOrderSample(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const lang = yield select(state => state.language.name);

		const result = yield call(validateForConciliation, payload.payload, token);

		if (result && result.validarAmostraPedidoParaConciliacao) {
			let resultData = result.validarAmostraPedidoParaConciliacao

			if (resultData.success) {
				yield put({ 
					type: "SET_ORDER_SAMPLE_REDIRECT", 
					payload: {
						redirect: true,
						showToast: false,
						message: '',
						messageType: "toast-success"
				}});
			} else {
				yield put({ 
					type: "SET_ORDER_SAMPLE_REDIRECT", 
					payload: {
						redirect: false,
						showToast: true,
						message: resultData.messageError,
						messageType: "toast-error"
				}});
			}
        } else {
			yield put({ 
				type: "SET_ORDER_SAMPLE_REDIRECT", 
				payload: {
					redirect: false,
					showToast: true,
					message: messages[lang].internalError,
					messageType: "toast-error"
			}});
		}
        
	} catch (error) {
		log.info(error);
	}
}

// //Generator function
export function* orderSampleWatcher() {
	yield takeLatest("GET_ORDER_SAMPLES", getOrderSamples);
    yield takeLatest("GET_ORDER_SAMPLE_DETAILS", getOrderSampleDetails);
	yield takeLatest("SAVE_ORDER_SAMPLE", saveOrderSample);
	yield takeLatest("VALIDATE_ORDER_SAMPLE", validateOrderSample);
}
